import { Button } from 'antd';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import lang from '../../../fakedata/language.json';
import { selectTheme, setThemeLocale } from '../../../features/theme/themeSlice';
import { nazioni } from '../../../lang/nazioni';

type LanguageSelectorProps = {
	onChange?: () => void;
	footer?: boolean
};

const LanguageSelector = ({ onChange, footer }: LanguageSelectorProps) => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const { language: locale } = useAppSelector(selectTheme);
	const dispatch = useDispatch();

	return (
		<>
		{
			lang.map((l, i) => {
				const nazione = nazioni.filter(n => n.id === l.id);
				return (
					<Button 
						type="link" 
						className="ant-dropdown-link settings-link" 
						key={i} 
						style={{
							background: locale == l.langId && "#529cd5", 
							border: 'none',
							borderRadius: footer && i==0 && "30px 2px 2px 2px"
						}}
						onClick={(e) => {e.preventDefault(); dispatch(setThemeLocale(l.langId))}}
						>
						<img style={{ maxWidth: '20px'}} src={`data:image/png;base64,${nazione[0].flag}`} alt={nazione[0].name} />
						&nbsp;
						<span className="ml-1 white">
							{l.langName}
						</span>
					</Button>
				)
			})
		}
		</>
	)
};

export default LanguageSelector;
